import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledTextProps } from './BookingStagesInformation.types';

export const StyledText = styled.div<IStyledTextProps>`
  font-weight: 400;
  font-size: ${rem('12px')};
  font-style: italic;
  color: ${({ theme, isRejected }) =>
    isRejected ? theme.colors.cross.red : theme.colors.cross.grarson};
`;
